import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

// import { RadioGroup } from 'views/components/RadioGroup/RadioGroup';
import { Button } from 'views/components/Button/Button';
import SVGs from 'tools/utilities/svg-content';
import { IconTypes, Icon } from 'views/components/Icon/Icon';

// const OPTIONS = [
//   {
//     id: 'option-one',
//     label: 'Option One',
//     value: 'one',
//   },
//   {
//     id: 'option-two',
//     label: 'Option Two',
//     value: 'two',
//   },
//   {
//     id: 'option-three',
//     label: 'Option Three',
//     value: 'three',
//   },
// ];

interface IProps extends RouteComponentProps {
  isLoading?: boolean;
}

const PreviewPage = ({ isLoading }: IProps) => (
  <>
    <main className="Main" data-loaded={!isLoading}>
      <div className="Container">
        <h1>H1 - lorem ipsum dolor sit amet</h1>
        <h2>H2 - lorem ipsum dolor sit amet</h2>
        <h3>H3 - lorem ipsum dolor sit amet</h3>
        <h4>H4 - lorem ipsum dolor sit amet</h4>
        <h5>H5 - lorem ipsum dolor sit amet</h5>
        <h6>H6 - lorem ipsum dolor sit amet</h6>
        <p className="lead">1234567890</p>
        <p>
            Body - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec varius, ex nec
            sodales ultrices, odio nulla euismod nunc, a pharetra nisi ligula ac elit. Suspendisse
            scelerisque eu massa aliquet malesuada…
        </p>
        <p className="small">
            Body Small - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec varius, ex
            nec sodales ultrices, odio nulla euismod nunc, a pharetra nisi ligula ac elit.
            Suspendisse scelerisque eu massa aliquet malesuada…
        </p>

        <hr />
        <br />
        <h3>SVG Icons</h3>
        <div className="u-flex u-flexWrap" style={{ backgroundColor: 'lightGrey', padding: '10px', display: 'inline-block' }}>
          {Object.keys(SVGs).map((key: string) => (
            <div key={key} className="u-mL-md">
              <p>{key}</p>
              <Icon name={key as IconTypes} />
            </div>
          ))}
        </div>

        <hr />
        <br />
        <br />
        <h3>Button - Primary</h3>
        <Button onClick={() => {}} className="Button Button--primary" label="Normal" />
        <br />
        <br />
        <Button onClick={() => {}} className="Button Button--primary" label="Disabled" isDisabled />
        <br />
        <br />
        <Button onClick={() => {}} className="Button Button--primary" label="Loading" isLoading />
        <br />
        <br />

        <h3>Button - Secondary</h3>
        <Button onClick={() => {}} className="Button Button--secondary" label="Normal" />
        <br />
        <br />
        <Button
          onClick={() => {}}
          className="Button Button--secondary"
          label="Disabled"
          isDisabled
        />
        <br />
        <br />
        <Button onClick={() => {}} className="Button Button--secondary" label="Loading" isLoading />
        <br />
        <br />

        <h3>Button - Tertiary</h3>
        <span style={{ backgroundColor: 'lightGrey', padding: '10px', display: 'inline-block' }}>
          <Button onClick={() => {}} className="Button Button--tertiary" label="Normal" />
          <br />
          <br />
          <Button
            onClick={() => {}}
            className="Button Button--tertiary"
            label="Disabled"
            isDisabled
          />
          <br />
          <br />
          <Button
            onClick={() => {}}
            className="Button Button--tertiary"
            label="Loading"
            isLoading
          />
        </span>

        {/* <RadioGroup
          checkedValue="two"
          onChange={() => { }}
          name="MyRadioExample"
          options={OPTIONS}
        /> */}
      </div>
    </main>
  </>
);

export const Preview = withRouter(PreviewPage);
